import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Root = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutrals.beige1
}));

export const RootCenter = styled(Box)(({ theme }) => ({
  margin: '0 auto',
  width: '776px',
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}));
